/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
import {
  assign,
  createMachine,
  ErrorPlatformEvent,
  Interpreter,
} from 'xstate-v4'
import { ChangePasswordErrors } from './types'
import { ChangeUserPasswordRepositoryFetch } from './ChangeUserPasswordRepositoryFetch'
import sentryCapture from '../../utility/sentryCapture'

export type ChangeUserPasswordEvent =
  | { type: 'SUBMIT' }
  | { type: 'CHANGE_CURRENT_PASSWORD'; value: string }
  | { type: 'CHANGE_NEW_PASSWORD'; value: string }

export interface ChangeUserPasswordContext {
  errors?: ChangePasswordErrors
  currentPassword: string
  newPassword: string
}

function getContextInitial(): ChangeUserPasswordContext {
  return {
    currentPassword: '',
    newPassword: '',
  }
}

export function returnChangeUserPasswordMachine() {
  return createMachine<ChangeUserPasswordContext, ChangeUserPasswordEvent>(
    {
      context: getContextInitial(),
      initial: 'idle',
      states: {
        idle: {
          initial: 'normal',
          on: {
            SUBMIT: 'changing',
            CHANGE_CURRENT_PASSWORD: {
              actions: assign({
                currentPassword: (_, { value }) => value,
              }),
              target: 'idle',
              internal: true,
            },
            CHANGE_NEW_PASSWORD: {
              actions: assign({
                newPassword: (_, { value }) => value,
              }),
              target: 'idle',
              internal: true,
            },
          },
          states: {
            normal: {
              onEntry: assign({
                errors: (_) => undefined,
              }),
            },
            errors: {
              entry: assign({
                errors: (_, { data }: any) => data.errors || undefined,
              }),
            },
          },
        },
        changing: {
          invoke: {
            src: 'changeUserPassword',
            onDone: {
              target: 'changed',
            },
            onError: [
              {
                target: 'idle.errors',

                cond: (_, { data }) => !!data.errors,
              },
              {
                target: 'idle.errors',
                actions: 'logError',
              },
            ],
          },
        },
        changed: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event

          event.data.name = 'changeUserPasswordMachine ' + event.type + ' error'
          sentryCapture(event.data, 'userChangePasswordMachine')
        },
      },
      services: {
        changeUserPassword: ({ currentPassword, newPassword }) => {
          const repo = new ChangeUserPasswordRepositoryFetch()
          return repo.change(currentPassword, newPassword)
        },
      },
    },
  )
}

export type ChangeUserPasswordMachineInterpreter = Interpreter<
  ChangeUserPasswordContext,
  any,
  ChangeUserPasswordEvent
>
